import { IGetRecordResponse } from '@principle-theorem/practice-migrations/interfaces';
import { ExactAppointment } from '../../../source/entities/patient-appointment';

export class ExactAppointmentMatcher {
  private _appointments: IGetRecordResponse<ExactAppointment>[];

  constructor(
    appointments: IGetRecordResponse<ExactAppointment>[],
    private _getComparisonValueFn: (
      appointment: IGetRecordResponse<ExactAppointment>
    ) => string
  ) {
    this._appointments = appointments;
  }

  remainingResults(): IGetRecordResponse<ExactAppointment>[] {
    return [...this._appointments];
  }

  filterMatches(
    comparisonValue: string
  ): IGetRecordResponse<ExactAppointment>[] {
    return this._appointments.filter(
      (appointment) =>
        this._getComparisonValueFn(appointment) === comparisonValue
    );
  }

  findMatch(
    comparisonValue: string
  ): IGetRecordResponse<ExactAppointment> | undefined {
    return this._appointments.find(
      (appointment) =>
        this._getComparisonValueFn(appointment) === comparisonValue
    );
  }

  findMatchBy(
    comparisonValue: string,
    comparisonFn: (appointment: IGetRecordResponse<ExactAppointment>) => string
  ): IGetRecordResponse<ExactAppointment> | undefined {
    return this._appointments.find(
      (appointment) => comparisonFn(appointment) === comparisonValue
    );
  }

  removeMatch(appointment: IGetRecordResponse<ExactAppointment>): void {
    this._appointments = this._appointments.filter(
      (existing) => existing.record.uid !== appointment.record.uid
    );
  }
}
